export type ApiErrorData = {
    ok: false;
    error: string;
    fieldErrors?: Record<string, string>;
};

export type ExtractedApiError = {
    message: string;
    fieldErrors?: Record<string, string>;
};

/**
 * Extrai mensagem de erro e erros de campo de um erro Axios de forma padronizada.
 * Espera que o backend retorne `{ ok: false, error: string, fieldErrors?: Record<string, string> }`.
 */
export function extractApiError(error: unknown, fallback: string): ExtractedApiError {
    if (error !== null && typeof error === 'object' && 'response' in error) {
        const data = (error as any).response?.data as Partial<ApiErrorData> | undefined;
        return {
            message: (data as any)?.msg || data?.error || fallback,
            fieldErrors: data?.fieldErrors,
        };
    }
    return { message: fallback };
}
